import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["toggle", "ampTabEditor", "htmlTabEditor", "ampEditor", "htmlEditor", "ampPreviewSelector", "iframe"]

  toggleEditor(event) {
    let amp_on = event.currentTarget.checked
    this.ampTabEditorTarget.classList.toggle("is-hidden", !amp_on)
    this.ampTabEditorTarget.classList.toggle("is-active", amp_on)


    if (amp_on) {
      this.ampTabEditorTarget.removeAttribute("disabled")
      this.ampPreviewSelectorTarget.options[0].disabled = false
      this.ampPreviewSelectorTarget.selectedIndex = 0
      this.ampPreviewSelectorTarget.removeAttribute("disabled")
      this.iframeTarget.setAttribute("src", this.ampPreviewSelectorTarget.options[0].value)
    }
    else {
      this.ampPreviewSelectorTarget.setAttribute("disabled", true)
      this.ampTabEditorTarget.setAttribute("disabled", true)
      this.ampPreviewSelectorTarget.options[0].disabled = true
      this.ampPreviewSelectorTarget.selectedIndex = 1
      this.ampPreviewSelectorTarget.setAttribute("disabled", true)
      this.iframeTarget.setAttribute("src", this.ampPreviewSelectorTarget.options[1].value)
    }

    // The HTML tab stays visible either way: it is the only editable template,
    // and the server renders both tabs when AMP is on. Only the active state moves.
    this.htmlTabEditorTarget.classList.toggle("is-active", !amp_on)

    this.ampEditorTarget.classList.toggle("is-hidden", !amp_on)
    this.ampEditorTarget.classList.toggle("is-active", amp_on)

    this.htmlEditorTarget.classList.toggle("is-active", !amp_on)
    this.htmlEditorTarget.classList.toggle("is-hidden", amp_on)
  }
}
